import { inject, Injectable, Injector } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { LearningSectionEntity } from '../learning-section-entity';
import { ConsumerEntityService } from '../../consumer/services/consumer.entity.service';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';
import {
  LearningSectionContainerEntityService
} from '../learning-section-container/services/learning-section-container.entity.service';
import {
  LearningSectionLayoutEntityService
} from '../learning-section-layout/services/learning-section-layout.entity.service';
import { LearningUnitEntityService } from '../../learning-unit/services/learning-unit.entity.service';

export const STATE_NAME = 'learningSectionEntity';

export const LearningSectionEntityState: GenericEntityStateClass<LearningSectionEntity> =
  createEntityState<LearningSectionEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class LearningSectionEntityService extends EntityService<LearningSectionEntity> {
  private injector = inject(Injector);
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);
  private learningSectionContainerService = inject(LearningSectionContainerEntityService);
  private learningSectionLayoutService = inject(LearningSectionLayoutEntityService);

  constructor() {
    super();
    this.resourceType = 'learning-sections';
    this.stateClass = LearningSectionEntityState;

    this.registerLazyRelation(
      'learning-units',
      () => this.injector.get(LearningUnitEntityService)
    );
    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
    this.registerRelation('learning-section-containers', this.learningSectionContainerService);
    this.registerRelation('learning-section-layouts', this.learningSectionLayoutService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (state: any) => {
      const slice = state[STATE_NAME];
      return this.stateClass.allByQuery(slice, { query });
    };
  }
}
